import { createStyles } from '@mantine/core';

const useAssignPayRatesTableStyles = createStyles(theme => ({
  table: {
    paddingBottom: theme.spacing.xs,
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    flexGrow: 0,
    flexShrink: 0,
    gridTemplateRows: 'auto',
  },
}));

export default useAssignPayRatesTableStyles;
